import { Box, Typography } from "@mui/material";
import { Archive } from "iconoir-react";

const Empty = ({
  icon = <Archive width={64} height={64} strokeWidth={1} />,
  description = "No Data",
  children = null,
  sx = {},
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      color="text.secondary"
      textAlign="center"
      sx={sx}
    >
      <Box mb={1}>{icon}</Box>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
      {children && <Box mt={2}>{children}</Box>}
    </Box>
  );
};

export default Empty;
